import React from 'react';
import Hammer from 'react-hammerjs';
import { isUndefined } from 'lodash';

interface GesturesProviderProps {
  children: React.ReactNode;
  onPinch(event: any): void;
}

function GesturesProvider({ children, onPinch }: GesturesProviderProps) {
  const [center, setCenter] = React.useState<any>(undefined);
  const [timer, setTimer] = React.useState<any>(undefined);

  const onPinchStart = React.useCallback(
    (event) => setCenter(event.center),
    [],
  );

  const onPinchEnd = React.useCallback(() => setCenter(undefined), []);

  function pinchHandler(event) {
    if (isUndefined(timer)) {
      setTimer(
        setTimeout(() => {
          const deltaY = event.type === 'pinchin' ? 1 : -1;
          onPinch({ ...event, deltaY, center });
          setTimer(undefined);
        }, 50),
      );
    }
  }

  return (
    <Hammer
      onPinchStart={onPinchStart}
      onPinchEnd={onPinchEnd}
      onPinchIn={pinchHandler}
      onPinchOut={pinchHandler}
      options={{
        recognizers: {
          pinch: { enable: true },
        },
      }}>
      <div>{children}</div>
    </Hammer>
  );
}

export default GesturesProvider;
